import { useAuth } from "./auth";
import { LoginPage} from "./pages/LoginPage";
import { useTranslate } from "@/helper/translate";

export function AuthGate({ children }: { children: React.ReactNode }) {
  const { translate } = useTranslate();
  const { initializing, accessToken } = useAuth();

  if (initializing) return <div className="w-full text-center my-10">{translate("common.loading")}</div>;     // optional splash
  if (!accessToken) return <LoginPage />;               // show your login page/component
  return <>{children}</>;
}